// extracted by css-extract-rspack-plugin
export default {"wrapper":"wrapper--uB0BID0V4KAdcGE5","inputBlock":"input-block--ebrKJteQ4HQt9moz","inputSeparator":"input-separator--bqWxT1vWp4xyVFOW"};